"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var paymentStyles = styles_1.makeStyles(function (theme) {
    var _a, _b;
    return ({
        container: (_a = {
                display: 'block',
                width: '100%',
                height: 'fit-content',
                maxWidth: '560px',
                minHeight: '670px',
                margin: '0 auto',
                padding: '40px',
                background: theme.palette.background.alternate
            },
            _a[theme.breakpoints.down('xs')] = {
                width: 'auto',
                height: 'auto',
                padding: '20px 0',
            },
            _a['& iframe'] = {
                width: '100%',
                minHeight: 'inherit',
                border: 'none',
            },
            _a),
        formHeader: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'baseline',
            padding: '20px',
        },
        headerItem: {
            display: 'flex',
            flexBasis: '50%',
        },
        logosWrapper: {
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        disclaimersContainer: (_b = {
                whiteSpace: 'pre-wrap',
                marginTop: '20px',
                padding: '0 20px'
            },
            _b[theme.breakpoints.down('sm')] = {
                wordBreak: 'break-word',
            },
            _b),
        subTitle: {
            margin: "0 0 " + theme.spacing(2) + " 0",
            fontWeight: theme.typography.fontWeightBold,
        },
        paragraph: {
            margin: "0 0 " + theme.spacing(2) + " 0",
            whiteSpace: 'pre-wrap',
        },
        highlighted: {},
        saveDealButton: {
            maxWidth: '350px',
            width: '100%',
        },
        alignCenter: {
            display: 'flex',
            justifyContent: 'center',
        },
    });
}, { name: 'GqlCheckout_Payment_Apexx' });
exports.default = paymentStyles;
